type RuntimeConfig = Partial<Record<string, string>>;

declare global {
  interface Window {
    __APP_CONFIG__?: RuntimeConfig;
  }
}

const getRuntimeConfigScriptBaseUrl = (): string => {
  const baseUrl = import.meta.env.BASE_URL || '/';
  return `${baseUrl.replace(/\/$/, '')}/runtime-config`;
};

const getLocalRuntimeConfigScriptUrl = (): string => {
  const baseUrl = import.meta.env.BASE_URL || '/';
  return `${baseUrl.replace(/\/$/, '')}/runtime-config.local.js`;
};

const loadScript = async (src: string): Promise<void> => {
  await new Promise<void>((resolve) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.head.appendChild(script);
  });
};

export const loadRuntimeConfig = async (): Promise<void> => {
  await loadScript(getRuntimeConfigScriptBaseUrl());

  if (!window.__APP_CONFIG__) {
    await loadScript(`${getRuntimeConfigScriptBaseUrl()}.js`);
  }

  if (!window.__APP_CONFIG__) {
    await loadScript(getLocalRuntimeConfigScriptUrl());
  }
};

export const getRuntimeEnv = (key: string, fallback?: string): string => {
  const runtimeValue = window.__APP_CONFIG__?.[key];
  if (typeof runtimeValue === 'string' && runtimeValue.length > 0) return runtimeValue;
  if (typeof fallback === 'string') return fallback;
  return '';
};
